import React, { useContext } from 'react';
import {ActivityContext} from '../../index';
import styles from '../../index.module.scss';
import CONSTANTS from '../../constant';
import { Balloon, NumberPicker, Radio, Select } from '@alifd/next';
function TriggerEvent() {
  const { task, taskParams, setTaskParams, pageDisable } = useContext(ActivityContext);
  return (
    <div className={styles['cardBox']}>
      <div className={styles['titleBox']}>触发事件：</div>
      {
        CONSTANTS.TRIGGER_EVENT_TEXT[task] ? 
        CONSTANTS.TRIGGER_EVENT_TEXT[task] : 
        (
          (task === 'S_DDCF' || task==='S_YSCF') &&
          <div>
            <Radio.Group
              direction={'hoz'}
              value={taskParams.triggerEvent[task].triggerType}
              disabled={pageDisable}
              onChange={(v) =>{
                let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                setTaskParams({ 
                  ...taskParams,
                  triggerEvent:{
                    [task]:{
                      ...newTriggerEventTask,
                      triggerType:+v,
                      number:'',
                      unit:'min',
                    }
                  }
                })
              }}
            >
              <Radio value={1}>
                <div className={styles['radioSmallBox']}>
                  {{'S_DDCF':'消费者提交订单','S_YSCF':`${+taskParams.triggerEvent[task].paymentReminderType===1?'尾款支付开始':'提交定金订单'}`}[task]}
                  <Balloon.Tooltip
                    align='t'
                    trigger={
                      <NumberPicker
                        hasTrigger={false}
                        min={1}
                        max={CONSTANTS.UNIT_MAX_NUM[taskParams.triggerEvent[task].unit]}
                        disabled={pageDisable || +taskParams.triggerEvent[task].triggerType !== 1}
                        value={+taskParams.triggerEvent[task].triggerType === 1 ? taskParams.triggerEvent[task].number : ''}
                        onChange={(v)=>{
                          let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                          setTaskParams({ 
                            ...taskParams,
                            triggerEvent:{
                              [task]:{
                                ...newTriggerEventTask,
                                number:v ? +v : ''
                              }
                            }
                          })
                        }}
                      />
                    }
                  >
                    系统获取订单状态需要一定时间，设置时间过短,可能无法第一时间发送短信
                  </Balloon.Tooltip>
                  <Select
                    dataSource={CONSTANTS.SELECT_TIME_DATA_SOURCE}
                    disabled={pageDisable || +taskParams.triggerEvent[task].triggerType !== 1}
                    value={+taskParams.triggerEvent[task].triggerType === 1 ? taskParams.triggerEvent[task].unit : 'min'}
                    onChange={(v)=>{
                      let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                      setTaskParams({ 
                        ...taskParams,
                        triggerEvent:{
                          [task]:{
                            ...newTriggerEventTask,
                            unit:v,
                            number:''
                          }
                        }
                      })
                    }}
                  />
                  后仍未付款
                </div>
              </Radio>
              <Radio value={2}>
                <div className={styles['radioSmallBox']}>
                  {{'S_DDCF':'距离订单取消仅剩余','S_YSCF':`${+taskParams.triggerEvent[task].paymentReminderType===1?'距离尾款支付结束时间仅剩余':'距离定金订单取消仅剩余'}`}[task]}
                  <Balloon.Tooltip
                    align='t'
                    trigger={
                      <NumberPicker
                        hasTrigger={false}
                        min={1}
                        max={CONSTANTS.UNIT_MAX_NUM[taskParams.triggerEvent[task].unit]}
                        disabled={pageDisable || +taskParams.triggerEvent[task].triggerType !== 2}
                        value={+taskParams.triggerEvent[task].triggerType === 2 ? taskParams.triggerEvent[task].number : ''}
                        onChange={(v)=>{
                          let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                          setTaskParams({ 
                            ...taskParams,
                            triggerEvent:{
                              [task]:{
                                ...newTriggerEventTask,
                                number:v ? +v : ''
                              }
                            }
                          })
                        }}
                      />
                    }
                  >
                    系统获取订单状态需要一定时间，设置时间过短,可能无法第一时间发送短信
                  </Balloon.Tooltip>
                  <Select
                    dataSource={CONSTANTS.SELECT_TIME_DATA_SOURCE}
                    disabled={pageDisable || +taskParams.triggerEvent[task].triggerType !== 2}
                    value={+taskParams.triggerEvent[task].triggerType === 2 ? taskParams.triggerEvent[task].unit : 'min'}
                    onChange={(v)=>{
                      let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                      setTaskParams({ 
                        ...taskParams,
                        triggerEvent:{
                          [task]:{
                            ...newTriggerEventTask,
                            unit:v,
                            number:''
                          }
                        }
                      })
                    }}
                  />
                  仍未付款
                </div>
              </Radio>
            </Radio.Group>
          </div>
          ||
          (task === 'S_SHSQ'|| task === 'S_JJSH' || task === 'S_TYTK' || task === 'S_SHCG') &&
          <div className={styles['radioSmallBox']}>
            {{'S_SHSQ':'消费者申请','S_JJSH':'商家拒绝消费者的','S_TYTK':'商家同意消费者的','S_SHCG':'消费者的'}[task]}
            <Select
              mode='multiple'
              style={{minWidth:'150px'}}
              disabled={pageDisable}
              dataSource={CONSTANTS.SELECT_ORDER_TYPE_DATA_SOURCE}
              value={taskParams.triggerEvent[task].triggerType}
              onChange={(v)=>{
                let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                setTaskParams({ 
                  ...taskParams,
                  triggerEvent:{
                    [task]:{
                      ...newTriggerEventTask,
                      triggerType:v,
                    }
                  }
                })
              }}
            />
            {{'S_SHSQ':'后立即发送短信','S_JJSH':'申请后发送短信','S_TYTK':'申请后发送短信','S_SHCG':'售后成功后发送短信'}[task]}
            
          </div>
          ||
          task === 'S_YCFH' &&
          <div>
            <Radio.Group
              direction={'hoz'}
              value={taskParams.triggerEvent[task].triggerType}
              disabled={pageDisable}
              onChange={(v) =>{
                let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                setTaskParams({ 
                  ...taskParams,
                  triggerEvent:{
                    [task]:{
                      ...newTriggerEventTask,
                      triggerType:+v,
                      number:'',
                      unit:'hours',
                    }
                  }
                })
              }}
            >
              <Radio value={1}>
                商家超时未发货后立即发送短信
              </Radio>
              <Radio value={2}>
                <div className={styles['radioSmallBox']}>
                  消费者提交订单
                  <Balloon.Tooltip
                    align='t'
                    trigger={
                      <NumberPicker
                        hasTrigger={false}
                        min={1}
                        max={CONSTANTS.UNIT_MAX_NUM[taskParams.triggerEvent[task].unit]}
                        disabled={pageDisable || +taskParams.triggerEvent[task].triggerType !== 2}
                        value={+taskParams.triggerEvent[task].triggerType === 2 ? taskParams.triggerEvent[task].number : ''}
                        onChange={(v)=>{
                          let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                          setTaskParams({ 
                            ...taskParams,
                            triggerEvent:{
                              [task]:{
                                ...newTriggerEventTask,
                                number:v ? +v : ''
                              }
                            }
                          })
                        }}
                      />
                    }
                  >
                    {/* 系统获取订单状态需要一定时间，设置时间过短,可能无法第一时间发送短信 */}
                  </Balloon.Tooltip>
                  <Select
                    dataSource={CONSTANTS.SELECT_TIME_DATA_SOURCE1}
                    disabled={pageDisable || +taskParams.triggerEvent[task].triggerType !== 2}
                    value={+taskParams.triggerEvent[task].triggerType === 2 ? taskParams.triggerEvent[task].unit : 'hours'}
                    onChange={(v)=>{
                      let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                      setTaskParams({ 
                        ...taskParams,
                        triggerEvent:{
                          [task]:{
                            ...newTriggerEventTask,
                            unit:v,
                            number:''
                          }
                        }
                      })
                    }}
                  />
                  后仍未发货
                </div>
              </Radio>
            </Radio.Group>
          </div> 
          ||
          (task === 'S_FKGH' || task === 'S_DDCP') &&
          <div className={styles['radioSmallBox']}>
             {{'S_FKGH':'消费者付款','S_DDCP':'确认收货'}[task]}
            <Balloon.Tooltip
              align='t'
              trigger={
                <NumberPicker
                  hasTrigger={false}
                  min={1}
                  max={CONSTANTS.UNIT_MAX_NUM[taskParams.triggerEvent[task].unit]}
                  value={taskParams.triggerEvent[task].number}
                  disabled={pageDisable}
                  onChange={(v)=>{
                    let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                    setTaskParams({ 
                      ...taskParams,
                      triggerEvent:{
                        [task]:{
                          ...newTriggerEventTask,
                          number:v ? +v : ''
                        }
                      }
                    })
                  }}
                />
              }
            >
              系统获取订单状态需要一定时间，设置时间过短,可能无法第一时间发送短信
            </Balloon.Tooltip>
            <Select
              dataSource={CONSTANTS.SELECT_TIME_DATA_SOURCE2}
              value={taskParams.triggerEvent[task].unit}
              disabled={pageDisable}
              onChange={(v)=>{
                let newTriggerEventTask = {...taskParams.triggerEvent[task]}
                setTaskParams({ 
                  ...taskParams,
                  triggerEvent:{
                    [task]:{
                      ...newTriggerEventTask,
                      unit:v,
                      number:''
                    }
                  }
                })
              }}
            />
            {{'S_FKGH':'后发送短信','S_DDCP':'后仍未评价的订单，向消费者发送短信'}[task]}
          </div>
        )  
      }
    </div>
  );
}

export default TriggerEvent;
